import { ENV } from '~/common/enums/enums';
import { SeoPayload } from '~/common/types/types';

const seoPayload: SeoPayload = {
  title: 'seo.about.title',
  description: 'seo.about.description',
  siteUrl: ENV.APP.URL,
};

export { seoPayload };
